import React from 'react'
import { BestsellersType } from '../../types/TemplateConfiguration'
import { PageLevel, ProductRecommendationsList } from '../../types/Recommendations'
import ProductRecommendationsGrid from '../ProductRecommendationsGrid/ProductRecommendationsGrid'
import { type ExtendedMtsLocalizationResponse } from '@vp/ep-tiles'
import { DebugPageSections } from '../debugComponents/DebugPageSections'
import { getDesktopTilesPerRow } from '../../utils/recommendations/productRecommendationsBuilder'
import { type AdaptedResponse } from '@vp/product-recommendations-tracking'
import { useAppContext } from '../../state/AppContext'
import { useBestsellersTracking } from './useBestsellersTracking'

interface BestsellersProps {
  section: BestsellersType
  sectionNumber: number
  productRecommendations: ProductRecommendationsList | null
  adaptedResponse?: AdaptedResponse
  pageLevel?: PageLevel | null
  sidebarEnabled?: boolean
  calloutsLocalization: ExtendedMtsLocalizationResponse
}

const Bestsellers = ({
  section,
  sectionNumber,
  productRecommendations,
  adaptedResponse,
  pageLevel,
  sidebarEnabled = false,
  calloutsLocalization
}: BestsellersProps) => {
  const products = productRecommendations?.products ?? []

  if (products.length === 0) return null

  const { merchandisingCategoryId } = useAppContext()
  const isL2 = pageLevel === 'L2'
  const tilesPerRow = getDesktopTilesPerRow(products.length, sidebarEnabled)
  const colSpan: 6 | 4 | 3 | 2 = tilesPerRow === 6 ? 2 : 3
  const headerColSpan: 5 | 7 = sidebarEnabled ? 7 : 5

  const { setRowRef, onTileClick } = useBestsellersTracking({
    adaptedResponse,
    products,
    desktopTilesPerRow: tilesPerRow,
    pageSection: `Bestsellers ${sectionNumber}`,
    merchandisingCategoryId
  })

  return (
    <>
      <ProductRecommendationsGrid
        title={isL2 ? section.title?.value : undefined}
        subtitle={isL2 ? section.subtitle?.value : undefined}
        products={products}
        colSpan={colSpan}
        headerColSpan={headerColSpan}
        pageSection={`Bestsellers ${sectionNumber}`}
        calloutsLocalization={calloutsLocalization}
        tilesPerRow={tilesPerRow}
        setRowRef={setRowRef}
        onTileClick={onTileClick}
      />
      <DebugPageSections
        rawSectionData={{ section, productRecommendations, calloutsLocalization }}
      />
    </>
  )
}

export default Bestsellers
